// extracted by mini-css-extract-plugin
export default {"wrapper":"SuperRange_wrapper__S-Wk0","title":"SuperRange_title__3KeZt","slider":"SuperRange_slider__zjLgk"};